import Token from 'vindi-ds-tokens';

export default {
  advertsBox: {
    width: '92%',
  },
  headingBox: {
    marginBottom: Token.padding.inset.large.value,
  },
  paragraphBox: {
    marginBottom: Token.padding.inset.small.value,
  },
  paragraphDetails: {
    marginTop: Token.padding.inset.large.value,
    color: '#6F6F84',
    fontSize: '12px',
  },
  headingDetach: {
    color: Token.color.brand.secondary[500].value,
  },
};
